
<script>
    export default {
        template: '<input class="tag-input" type="text" v-model="editableTags">',
        props: ['value'],
        computed: {
            editableTags: {
                get () {
                    return this.value.join(' ')
                },
                set (val) {
                    this.$emit('input', val.split(' '))
                }
            }
        }
    }

</script>
<style lang="scss">
    .click-to-copy, .click-to-copy i {
        transition: all 0.5s;
    }
    .click-to-copy:hover, .click-to-copy:focus {
        zoom: 1.1;
    }
    .click-to-copy:hover i, .click-to-copy:focus i {
        color: #5867dd;
    }
    .product-image {
        width: 100%;
        height: auto;
        box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.3);
    }
    .z-depth-0 {
        box-shadow: none!important;
    }
    .z-depth-1 {
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
    }
    .z-depth-2 {
        box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.3);
    }
    .z-depth-3 {
        box-shadow: 0 8px 17px 2px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2);
    }
    .z-depth-4 {
        box-shadow: 0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px -7px rgba(0,0,0,0.2);
    }
    .tag-input{
        background-color: #eee;
        border: 0;
        height: 40px;
        padding: 20px;
        border-radius: 20px;
    }
</style>